import { parseResponse } from '../parseResponse';
import { endpoints } from '../endpoints';
import { getHeader } from './generalApi';

export async function sendToCache(credentials) {
  return fetch(`${endpoints.proxy}/saveTempCredentials`, {
    ...(await getHeader('POST')),
    body: JSON.stringify(credentials)
  }).then(parseResponse);
}

export async function clearCache(services) {
  return fetch(`${endpoints.proxy}/clearTempCredentials`, {
    ...(await getHeader('DELETE')),
    body: JSON.stringify(services)
  }).then(parseResponse);
}
